// @ts-nocheck
import * as Types from '../../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReserveYourBuild_SaveCheckoutConfigMutationVariables = Types.Exact<{
  input: Types.SaveCheckoutConfigInput;
}>;


export type ReserveYourBuild_SaveCheckoutConfigMutation = { __typename?: 'Mutation', saveCheckoutConfig: { __typename?: 'SaveCheckoutConfigResult', checkoutConfig: { __typename?: 'CheckoutConfig', id: string, status: Types.CheckoutConfigStatus, reservedAt?: Types.Scalars['DateTime']['input'] | null | undefined, expiresAt?: Types.Scalars['Date']['input'] | null | undefined, name?: string | null | undefined, customerEmail?: string | null | undefined, customerFirstName?: string | null | undefined, customerLastName?: string | null | undefined, customerPhone?: string | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } } };

export type ReserveYourBuildFlyout_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, name?: string | null | undefined, customerEmail?: string | null | undefined, customerFirstName?: string | null | undefined, customerLastName?: string | null | undefined, customerPhone?: string | null | undefined };

export const ReserveYourBuildFlyout_CheckoutConfigFragmentDoc = gql`
    fragment ReserveYourBuildFlyout_CheckoutConfig on CheckoutConfig {
  id
  name
  customerEmail
  customerFirstName
  customerLastName
  customerPhone
}
    `;
export const ReserveYourBuild_SaveCheckoutConfigDocument = gql`
    mutation ReserveYourBuild_SaveCheckoutConfig($input: SaveCheckoutConfigInput!) {
  saveCheckoutConfig(input: $input) {
    checkoutConfig {
      id
      status
      reservedAt
      expiresAt
      canEdit {
        allowed
        disabledReasons {
          message
        }
      }
      ...ReserveYourBuildFlyout_CheckoutConfig
    }
  }
}
    ${ReserveYourBuildFlyout_CheckoutConfigFragmentDoc}`;
export type ReserveYourBuild_SaveCheckoutConfigMutationFn = Apollo.MutationFunction<ReserveYourBuild_SaveCheckoutConfigMutation, ReserveYourBuild_SaveCheckoutConfigMutationVariables>;

/**
 * __useReserveYourBuild_SaveCheckoutConfigMutation__
 *
 * To run a mutation, you first call `useReserveYourBuild_SaveCheckoutConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReserveYourBuild_SaveCheckoutConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reserveYourBuildSaveCheckoutConfigMutation, { data, loading, error }] = useReserveYourBuild_SaveCheckoutConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReserveYourBuild_SaveCheckoutConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReserveYourBuild_SaveCheckoutConfigMutation, ReserveYourBuild_SaveCheckoutConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReserveYourBuild_SaveCheckoutConfigMutation, ReserveYourBuild_SaveCheckoutConfigMutationVariables>(ReserveYourBuild_SaveCheckoutConfigDocument, options);
      }
export type ReserveYourBuild_SaveCheckoutConfigMutationHookResult = ReturnType<typeof useReserveYourBuild_SaveCheckoutConfigMutation>;
export type ReserveYourBuild_SaveCheckoutConfigMutationResult = Apollo.MutationResult<ReserveYourBuild_SaveCheckoutConfigMutation>;
export type ReserveYourBuild_SaveCheckoutConfigMutationOptions = Apollo.BaseMutationOptions<ReserveYourBuild_SaveCheckoutConfigMutation, ReserveYourBuild_SaveCheckoutConfigMutationVariables>;